import { createReducer } from 'services/reduxHelpers'
import { snackbarTypes } from 'reduxModules/actions/SnackbarActions'

/* ------------- Initial State ------------- */

export const initialState = {
  open: false,
  message: null,
  type: null
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [snackbarTypes.SHOW_SNACKBAR_ATTEMPT]: (_, { data: { type, message } }) => ({ 
    open: true,
    message,
    type
  }),
  [snackbarTypes.HIDE_SNACKBAR_ATTEMPT]: () => ({ 
    open: false,
    message: null,
    type: null
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/SnackbarReducer.js